module.exports = __webpack_public_path__ + "img/image23.90afb373.jpeg";